// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://symdojhcmtptpjipuwmp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN5bWRvamhjbXRwdHBqaXB1d21wIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTcyNDc2ODIsImV4cCI6MjA3MjgyMzY4Mn0.T55qai9SryKhU_M3FlopXXz4Cg05rtWtG4Nn58iGSig";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});